import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { useAuth } from '../hooks/useAuth'

export default function Login() {
  const { signIn } = useAuth()
  const navigate   = useNavigate()

  const [credential, setCredential] = useState('')
  const [password, setPassword] = useState('')
  const [error,    setError]    = useState('')
  const [loading,  setLoading]  = useState(false)

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    setError('')

    if (!credential.trim()) {
      toast.error('Informe seu email ou usuário')
      return
    }
    if (!password) {
      toast.error('Senha é obrigatória')
      return
    }

    setLoading(true)
    try {
      await signIn(credential.trim(), password)
      navigate('/hoje')
    } catch (err) {
      setError('Credenciais incorretas.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="h-full w-full flex items-center justify-center bg-bg">
      <div className="w-[360px]">

        {/* Logo */}
        <div className="mb-10">
          <img
            src="/assets/images/logo-ifp.png"
            alt="IFP Arquitetura"
            className="w-12 h-auto object-contain mb-6"
          />
          <h1 className="text-[32px] font-extrabold tracking-[-0.03em] leading-none text-[#f0f0f0]">
            Área Restrita
          </h1>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="flex flex-col gap-6">

          <div className="flex flex-col gap-1">
            <label className="text-[9px] font-bold uppercase tracking-[0.12em] text-white/[0.35]">
              Email ou Usuário
            </label>
            <input
              type="text"
              value={credential}
              onChange={e => setCredential(e.target.value)}
              required
              autoFocus
              autoComplete="username"
              className="bg-transparent border-b border-white/10 text-white text-[14px] py-2 outline-none focus:border-white transition-colors"
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-[9px] font-bold uppercase tracking-[0.12em] text-white/[0.35]">
              Senha
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              className="bg-transparent border-b border-white/10 text-white text-[14px] py-2 outline-none focus:border-white transition-colors"
            />
          </div>

          {error && (
            <p className="text-[11px] text-vermelho">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="mt-2 bg-white text-black rounded-full py-2.5 px-6 text-[11px] font-bold uppercase tracking-[0.06em] cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed hover:bg-white/90 transition-opacity"
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>

        </form>
      </div>
    </div>
  )
}
